interface SectionHeadingProps {
  kicker: string;
  title: string;
  accent?: string;
  desc?: string;
  light?: boolean;
}

export default function SectionHeading({ kicker, title, accent, desc, light }: SectionHeadingProps) {
  return (
    <div className="mx-auto max-w-2xl text-center">
      <span
        className={`inline-flex items-center gap-2 text-sm font-medium tracking-wider ${
          light ? 'text-accent-300' : 'text-accent-600'
        }`}
      >
        <i className="ri-record-circle-line"></i>
        {kicker}
      </span>
      <h2
        className={`mt-3 font-heading text-3xl leading-tight md:text-4xl ${
          light ? 'text-background-50' : 'text-foreground-900'
        }`}
      >
        {title}
        {accent ? (
          <span className={light ? 'text-accent-300' : 'text-primary-600'}>{accent}</span>
        ) : null}
      </h2>
      {desc ? (
        <p className={`mt-4 leading-relaxed ${light ? 'text-background-100/90' : 'text-foreground-600'}`}>
          {desc}
        </p>
      ) : null}
    </div>
  );
}